<template>
    <div class="app-container">
        <div class="map-container">
            <pang-title :text="$router.lang.get('特色  地圖')" eng="Map"/>
            <div class="all-maps">
                <pang-map
                v-for="(map, i) in maps" :key="map.id"
                :cover="staticUrl + map.cover"
                :title="map.title"
                @click="showFullScreen(i)"/>
            </div>
            <pang-pager v-if="totalPages > 1" @change="goto" :totalPages="totalPages" :currentPage="currentPage"/>
        </div>
        <pang-map-full v-if="fullscreen" :cover="staticUrl + maps[currentMap].cover" @premap="preMap" @nextmap="nextMap" @close="closeFullScreen"/>
    </div>
</template>

<script>
import { useScreenState } from '../../store';
import request from '../../api/request'
import { PangTitle, PangPager, PangMap, PangMapFull } from '../../components'
import message from '../../utils/message'

export default {
    name: 'Map',
    components: {
        PangTitle,
        PangPager,
        PangMap,
        PangMapFull,
    },
    data () {
        return {
            screenState: useScreenState(),
            totalPages: 1,
            currentPage: 1,
            fullscreen: false,
            currentMap: 0,
            staticUrl: request.staticUrl,
            maps: [
            ]
        };
    },
    methods: {
        goto (page) {
            this.currentPage = page
            this.getMaps()
        },
        showFullScreen(i) {
            this.currentMap = i
            this.fullscreen = true
        },
        preMap () {
            if (this.currentMap > 0)
                this.currentMap--
        },
        nextMap () {
            if (this.currentMap < this.maps.length - 1)
                this.currentMap++
        },
        closeFullScreen () {
            this.currentMap = 0
            this.fullscreen = false
        },
        getMaps () {
            let params = {page: this.currentPage, limit: 8, banner_type: 3}
            let _this = this
            request.get('/banners' , params, _this).then(function (res) {
                if (res.status == 200) {
                    _this.totalPages = res.data.paging.total_pages
                    _this.currentPage = res.data.paging.page
                    _this.maps = res.data.results
                }
                else {
                    message.resMessage(res, _this)
                }
            })
        },
    },
    computed: {
        isCollapse() {
        return this.screenState.screenWidth < 900;
        },
    },
    mounted () {
        this.getMaps()
    },
}
</script>

<style scoped>
.map-container {
    margin-bottom: 70px;
}
.all-maps {
    max-width: 1057px;
    width: 90vw;
    margin: auto;
    margin: 70px auto;
}

.fullscreen {
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.68);
    position: fixed;
    top: 0;
    z-index: 99999;
}

.fullscreen-content {
    margin-top: 208px;
    display: flex;
}

.fullscreen-content > div:first-child{
    flex: revert;
    margin: auto;
    margin-right: 6.25vw;
}

.fullscreen-content > div:last-child{
    flex: revert;
    margin: auto;
    margin-left: 1.41vw;
}

.pre-butt {
    max-width: 39px;
    max-height: 62px;
    width: 2.03vw;
    height: 3.23vw;
    cursor: pointer;
}

.next-butt {
    max-width: 39px;
    max-height: 62px;
    width: 2.03vw;
    height: 3.23vw;
    margin-left: 4.84vw;
    cursor: pointer;
}

.fullscreen-map {
    max-width: 956px;
    min-height: 20vw;
    width: 77.5vw;
}

.close-butt {
    max-width: 87px;
    max-height: 96px;
    width: 4.53vw;
    height: 5vw;
    cursor: pointer;
}

.close-butt-container {
    position: absolute;
    top: 195px;
}

</style>
